<template>
  <FormContainer @submitForm="saveEquity">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome"
        v-model="equity.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputAmountWidget
        class="col-lg-4 col-sm-6"
        label="Importo"
        v-model.number="equity.importo"
        :min="0"
        :errorMsg="errorHash['importo']"
        @input="removeError('importo')"
      />

      <FormInputSelectWidget
        class="col-lg-4 col-sm-6"
        label="Tipo"
        v-model="equity.type"
        :options="types"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Data versamento"
        v-model="equity.begin"
        :errorMsg="errorHash['begin']"
        @input="removeError('begin')"
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva equity
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  name: 'operative-form-equity',
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
  },
  props: {
    equity: {
      type: Object,
      default: () => ({
        name: null,
        importo: null,
        type: 1,
        begin: null,
      }),
    },
    types: {
      type: Array,
      default: () => [
        { value: 1, label: 'Capitale Sociale' },
        { value: 2, label: 'Prestito Soci' },
        { value: 3, label: 'Riserve' },
      ],
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.equity.name) {
        this.addError('Il nome dell\'equity è obbligatorio', 'name');
      }

      if (!this.equity.importo) {
        this.addError('L\'importo dell\'equity è obbligatorio', 'importo');
      }

      if (!this.equity.begin) {
        this.addError('Il mese di riferimento è obbligatorio', 'begin');
      }

      return !this.hasErrors;
    },

    saveEquity () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.equity);
    },
  },
};

</script>
